import { render, staticRenderFns } from "./administrationReport.vue?vue&type=template&id=9bfac3dc&scoped=true&"
import script from "./administrationReport.vue?vue&type=script&lang=js&"
export * from "./administrationReport.vue?vue&type=script&lang=js&"
import style0 from "./administrationReport.vue?vue&type=style&index=0&id=9bfac3dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfac3dc",
  null
  
)

export default component.exports